/**
 * Header.js
 * Header component
 *
 * @class   Header
 * @author  Randy Lebeau
 * @author  Robert Sahm
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import Paper from 'components/paper/Paper';

export default React.createClass({

	displayName: 'Header',

	propTypes: {
		title: React.PropTypes.string.isRequired,
		tools: React.PropTypes.any,
		padded: React.PropTypes.bool
	},

	getDefaultProps() {
		return {
			tools: '',
			padded: true
		}
	},

	getInitialState() {
		return {
			position: null
		}
	},

	render() {

		let classes = ClassNames({
			"lui-sticky-header-paper": true,
			"lui-sticky-header-content": this.props.padded,
		});

		return(
			<div>
				<div>
					<div className="lui-font-style-toolbar lui-sticky-header-content lui-sticky-header-paper">
						<span>{this.props.title}</span>
						<span className="pull-right">{this.props.tools}</span>
					</div>
				</div>

				<div className={classes}>
					{this.props.children}
				</div>
			</div>
		);
	},

	getPosition() {

		let element = this.getDOMNode();
		let height = element.offsetHeight;

		return {
			title: this.props.title,
			tools: this.props.tools,
			height: height,
			element: element
		};
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/sticky-header/Header.js
 **/